// Shared design tokens for the affiliate portal — keeps every page consistent.
export const AFF = {
  accent: '#6366f1',
  accentSoft: 'rgba(99, 102, 241, 0.1)',
  accentGrad: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  ink: '#1e1e2d',
  muted: '#7e8299',
  border: '#eff2f5',
  success: '#50cd89',
  warning: '#ffc700',
  danger: '#f1416c',
  cardShadow: '0 6px 24px rgba(0,0,0,0.04)',
  radius: 16,
}

export const card: React.CSSProperties = {
  background: '#fff',
  borderRadius: AFF.radius,
  boxShadow: AFF.cardShadow,
  border: `1px solid ${AFF.border}`,
}
